import { render } from "./achi_title.vue?vue&type=template&id=277796c3&scoped=true"
import script from "./achi_title.vue?vue&type=script&lang=js"
export * from "./achi_title.vue?vue&type=script&lang=js"

import "./achi_title.vue?vue&type=style&index=0&id=277796c3&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277796c3"]])

export default __exports__